export const it = {
    LEFT: 'A sinistra: Spostare il giorno precedente.',
    RIGHT: 'A destra: Spostare al giorno successivo.',
    DOWN: 'Giù: Sposta alla riga successiva.',
    UP: 'Fino: Sposta alla riga precedente.',
    PGUP: 'Inizio: consente di passare al mese precedente.',
    PGDOWN: 'PgDown: passare al prossimo mese.',
    HOME: 'Home: Spostare all\'anno precedente.',
    END: 'Fine: Spostare al prossimo anno.',
    ESC: 'Esc/Oggi/Chiudi: chiude il calendario.',
    TITLE: 'Istruzioni Sulla Tastiera'
};
